export default __webpack_public_path__ + "static/media/blue.e47bcda7.svg";